import { CommonModule } from '@angular/common';
import { Component, Input, NO_ERRORS_SCHEMA, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogContentBase, DialogModule, DialogRef, WindowModule } from '@progress/kendo-angular-dialog';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { CasiCloseOptions } from '../../common/constants.lib';
import { LoggerService } from '../../shared/logger/logger.service';

@Component({
  selector: 'app-error-dialog-modal',
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule,
    InputsModule,
    ButtonsModule,
    DialogModule,
    WindowModule
  ],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './error-dialog-modal.component.html',
  styleUrl: './error-dialog-modal.component.scss'
})
export class ErrorDialogModalComponent  extends DialogContentBase implements OnInit{

  private _title: string | undefined;
  private _content: string = 'Content not set';
  private _buttonText: string = 'wtf';
  private _buttonText2: string = '';

  @Input({ required: true })
  set title(value: string) {
    this._title = value;
  }
  get title(): string | undefined {
    return this._title
  };

  @Input({ required: true })
  set content(val: string) {
    this._content = val;
  }
  get content() {
    return this._content;
  }

  @Input()
  set buttonText(val: string) {
    this._buttonText = val;
  }
  get buttonText() {
    return this._buttonText;
  };

  @Input()
  set buttonText2(val: string) {
    this._buttonText2 = val;
  }
  get buttonText2() {
    return this._buttonText2;
  };

  constructor(
    public override dialog: DialogRef,
    private logger: LoggerService,
  ) {
    super(dialog);
  }

  //#region Ng Events

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
  }

  //#endregion

  public errorClose(): void {
    this.logger.debug(`errorClose...`);
    this.dialog.close({ text: CasiCloseOptions.Closed });
  }

  public proceedAction(): void {
    this.logger.debug(`errorClose...`);
    this.dialog.close({ text: CasiCloseOptions.Ok });
  }

}

